module.exports = __webpack_public_path__ + "static/media/oberflex-eucalyptust6-2560x1440.b1cf2adc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/oberflex-eucalyptust6-2560x1440.jpg
// module id = 1013
// module chunks = 37